import { investorApi } from '@core/api/httpClient'
import { PROFILE_ENDPOINTS } from './profileEndpointPaths'
import {
  parseAccountStatus,
  parseKycDetails,
  parseKycStatus,
  parseUserProfile,
} from './profileParser'
import type { UpdateProfilePayloadDto } from './profileContracts'
import type {
  AccountStatus,
  KycDetails,
  KycStatus,
  UpdateProfileInput,
  UserProfile,
} from '../types/profileTypes'

export async function getUserProfile(): Promise<UserProfile> {
  const { data } = await investorApi.get<unknown>(PROFILE_ENDPOINTS.USER_PROFILE)
  return parseUserProfile(data)
}

export async function getAccountStatus(): Promise<AccountStatus> {
  const { data } = await investorApi.get<unknown>(PROFILE_ENDPOINTS.ACCOUNT_STATUS)
  return parseAccountStatus(data)
}

export async function getKycDetails(): Promise<KycDetails> {
  const { data } = await investorApi.get<unknown>(PROFILE_ENDPOINTS.KYC_DETAILS)
  return parseKycDetails(data)
}

export async function getKycStatus(): Promise<KycStatus> {
  const { data } = await investorApi.get<unknown>(PROFILE_ENDPOINTS.KYC_STATUS)
  return parseKycStatus(data)
}

export async function updateProfile(input: UpdateProfileInput): Promise<void> {
  const payload: UpdateProfilePayloadDto = {
    firstName: input.firstName,
    lastName: input.lastName,
  }
  await investorApi.patch<void>(PROFILE_ENDPOINTS.UPDATE_PROFILE, payload)
}

export async function reInitiateKyc(): Promise<void> {
  await investorApi.post<void>(PROFILE_ENDPOINTS.KYC_RE_INITIATE)
}
